export const tabLabels = ['Manufacturer', 'Operator (Beta)']
